<template>
  <div class="activity-detail">
    <header>
      <img :src=goodsMsg.thumbnil alt="" class="t-img">
      <p>
        <img src="../../assets/images/activity-img/activity-detail-img/icon-24-fanhui.png" alt="" @click="$router.replace('/')">
      </p>
    </header>
    <section>
      <!-- 活动介绍 -->
      <div class="activity-introduce">
        <!-- 活动标题 -->
        <p class="activity-title">
          {{goodsMsg.name}}
          <span v-for="(item,index,) in goodsMsg.lable" :key="index" :class="tagStyle(index)">
            {{item}}
          </span>
          <img src="../../assets/images/activity-img/activity-detail-img/fenxiang.png" alt="">
        </p>
        <!-- 活动详情 -->
        <div class="activity-msg">
          {{goodsMsg.desc}}
        </div>
      </div>
      <!-- 开通会员卡 -->
      <div class="open-card">
        <p>
          开通会员享受 <span>会员权益</span>
        </p>
        <p>
          立即开通
        </p>
      </div>
      <div class="activity-recommend">
        <p class="title">
          图文介绍
        </p>
        <p class="content" v-html="goodsMsg.detail">
          <img src="../../assets/images/activity-img/activity-detail-img/img1.png" alt="">
        </p>
      </div>
    </section>
    <footer>
      <p>
        <span>￥</span>
        <span>{{goodsMsg.price}}</span>
        <span>/人</span>
      </p>
      <p>
        立即购买
      </p>
    </footer>
  </div>
</template>
<script>
export default {
  data(){
    return{
      goodsId: '', // 商品id
      goodsMsg: [], // 商品详情
    }
  },
  created(){
    // 商品详情
    this.goodsId = this.$route.query.id
    // console.log(this.goodsId)
    this.$axios.get('/api//goods/index/detail?id='+this.goodsId).then((res) => {
      // console.log(res.data.data)
      this.goodsMsg = res.data.data
      // console.log(this.goodsMsg)
    })
  },
  methods:{
    // 标签样式
    tagStyle(index){
      return "person_" + index
    },
  }
}
</script>
<style lang="less" scoped>
  .activity-detail{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: 3.6rem;
      // 背景图
      .t-img{
        width: 100%;
        height: 3.6rem;
        position: relative;
      }
      p{
        width: 100%;
        position: absolute;
        top: 0;
        img{
          margin-top: .15rem;
          width: .48rem;
          height: .48rem;
          float: left;
          margin-left: .19rem;
        }
      }
    }
    section{
      width: 100%;
      flex: 1;
      z-index: 2;
      background: #F0F0F0;
      overflow: scroll;
      // 活动介绍
      .activity-introduce{
        width: 92%;
        // height: 2.31rem;
        margin: 0 auto;
        margin-top: .15rem;
        background: #ffffff;
        overflow: hidden;
        // 活动标题
        .activity-title{
          font-family: PingFang SC;
          color: #333333;
          font-weight: Bold;
          font-size: 0.36rem;
          line-height: .48rem;
          margin-top: .21rem;
          margin-left: .32rem;
          span{
            display: inline-block;
            width: .48rem;
            height: .24rem;
            font-size: .16rem;
            line-height: .24rem;
            color: #ffffff;
            border-radius:0.04rem;
            text-align: center;
          }
          .person_0{
            background: #FF0000;
            margin-left: .1rem;
          }
          .person_1{
            background: #7FBE39;
            margin-left: .04rem;
          }
          img{
            width: .48rem;
            height: .48rem;
            float: right;
            margin-right: .19rem;
          }
        }
        // 活动详情
        .activity-msg{
          font-family: PingFang SC;
          color: #999999;
          font-size: 0.24rem;
          margin-left: .33rem;
          margin-right: .38rem;
          line-height: .4rem;
          margin-top: .2rem;
          margin-bottom: .31rem;
        }
      }
      // 开通会员卡
      .open-card{
        width: 92%;
        height: .88rem;
        margin: 0 auto;
        line-height: .88rem;
        font-family: PingFang SC;
        font-size: 0.28rem;
        background: #ffffff;
        border-radius: .2rem;
        margin-top: .2rem;
        p{
          &:first-child{
            float: left;
            margin-left: .3rem;
            span{
              color: #EF8201;
            }
          }
          &:last-child{
            float: right;
            margin-right: .6rem;
            color: #EF8201;
          }
        }
      }
      // 图文介绍
      .activity-recommend{
        width: 92%;
        margin: 0 auto;
        background: #ffffff;
        margin-top: .2rem;
        border-radius: .2rem;
        overflow: hidden;
        .title{
          font-size: 0.32rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(51,51,51,1);
          line-height: .32rem;
          margin-top: .29rem;
          margin-left: .19rem;
          margin-bottom: .25rem;
        }
        .content{
          margin-left: .22rem;
          margin-right: .22rem;
          font-size:0.24rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(153,153,153,1);
          line-height: 0.3rem;
          padding-bottom: .3rem;
          img{
            width: 100%;
            margin-top: .12rem;
          }
        }
      }
    }
    footer{
      width: 100%;
      // height: 1.08rem;
      border-top: .01rem solid rgba(228,228,228,1);
      line-height: 1.08rem;
      p{
        &:first-child{
          font-family: PingFang SC;
          color: #333333;
          float: left;
          margin-left: .31rem;
          span{
            &:first-child{
              font-size: .48rem;
            }
            &:nth-child(2){
              color: #EF8201;
              font-size: 0.6rem;
            }
            &:last-child{
              font-size: 0.36rem;
            }
          }
        }
        &:last-child{
          float: right;
          width: 2.63rem;
          height: .7rem;
          margin-right: .29rem;
          background:rgba(239,130,1,1);
          border-radius: .35rem;
          margin-top: .2rem;
          line-height: .7rem;
          text-align: center;
          font-family:PingFang SC;
          font-weight:400;
          color:rgba(255,255,255,1);
        }
      }
    }
  }
</style>